import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { WorkflowVariable } from 'src/pages/WorkflowBuilder/workflow-advanced-models';

interface WorkflowVariablesListResponse {
  success: boolean;
  variables: WorkflowVariable[];
}

export default class WorkflowVariableService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getAll(): Promise<WorkflowVariable[]> {
    const response = await super.get<unknown, WorkflowVariablesListResponse>(api.workflow_variables);
    return response?.variables || [];
  }

  public async createVariable(data: {
    name: string;
    var_type: string;
    default_value?: string | number | boolean | null;
    value?: string | number | boolean | null;
  }): Promise<WorkflowVariable> {
    return super.post(api.workflow_variables, data);
  }

  public async updateVariable(
    id: string,
    data: {
      name?: string;
      default_value?: string | number | boolean | null;
      value?: string | number | boolean | null;
    },
  ): Promise<WorkflowVariable> {
    return super.put(`${api.workflow_variables}/${id}`, data);
  }

  public async deleteVariable(id: string): Promise<void> {
    return super.delete(`${api.workflow_variables}/${id}`, {});
  }
}
